/* eslint-disable react/no-array-index-key, react/prop-types, consistent-return */
import React, { useState, useEffect } from 'react';

import '../../assets/scss/components/ContadorRegressivo.scss';

import { getDatasFases } from '../../utils/fase';

const calcularTempo = (dataAlvo) => {
  const agora = new Date();
  const diff = dataAlvo - agora;

  if (diff <= 0) {
    return { horas: 0, minutos: 0, segundos: 0 };
  }

  const totalSegundos = Math.floor(diff / 1000);
  const horas = Math.floor(totalSegundos / 3600);
  const minutos = Math.floor((totalSegundos % 3600) / 60);
  const segundos = totalSegundos % 60;

  return { horas, minutos, segundos };
};

const pad = (n) => String(n).padStart(2, '0');

const DigitoAnimado = ({ valor }) => {
  const [prevValor, setPrevValor] = useState(valor);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (valor !== prevValor) {
      setAnimating(true);
      const timer = setTimeout(() => {
        setPrevValor(valor);
        setAnimating(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [valor, prevValor]);

  return (
    <span className="digito-container">
      <span className="digito-ghost" aria-hidden="true">
        {valor}
      </span>
      <span className={`digito-wrapper ${animating ? 'animating' : ''}`}>
        <span className="digito-prev">{prevValor}</span>
        <span className="digito-next">{valor}</span>
      </span>
    </span>
  );
};

const NumeroAnimado = ({ numero }) => {
  const digitos = pad(numero).split('');

  return (
    <span className="contador-regressivo__numero">
      {digitos.map((digito, idx) => (
        <DigitoAnimado key={idx} valor={digito} />
      ))}
    </span>
  );
};

const ContadorRegressivo = ({ cidade }) => {
  const dataAlvo = getDatasFases(cidade).INICIO_FASE_1;
  const [tempo, setTempo] = useState(calcularTempo(dataAlvo));

  useEffect(() => {
    setTempo(calcularTempo(dataAlvo));
    const interval = setInterval(() => {
      setTempo(calcularTempo(dataAlvo));
    }, 1000);

    return () => clearInterval(interval);
  }, [dataAlvo]);

  return (
    <div className="contador-regressivo">
      <p className="contador-regressivo__label">Faltam</p>
      <div className="contador-regressivo__grid">
        <div className="contador-regressivo__item">
          <NumeroAnimado numero={tempo.horas} />
          <span className="contador-regressivo__unidade">Horas</span>
        </div>
        <div className="contador-regressivo__item">
          <NumeroAnimado numero={tempo.minutos} />
          <span className="contador-regressivo__unidade">Minutos</span>
        </div>
        <div className="contador-regressivo__item">
          <NumeroAnimado numero={tempo.segundos} />
          <span className="contador-regressivo__unidade">Segundos</span>
        </div>
      </div>
    </div>
  );
};

export default ContadorRegressivo;
